import React, { useEffect, useState } from 'react'
import styles from './broadcastList.module.css';
import IMAGES from '../../../assets/images/images';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../../../components/loader/Loader";
import moment from 'moment';
import { filterAndMapIds, formatDate, futureDate } from '../../../utils/arrayUtils';
import {serviceReqColumnConfig } from '../../../utils/constants/incidentConstants';
import { USER_TYPE } from '../../../utils/constants/userConstants';
import Table from '../../../components/table/Table';
import SecondaryTooltip from '../../../components/secondaryToolTip/secondaryToolTip';
import Status from '../../../components/status/Status';
import { allCount, checkAllFalse } from '../../../utils/utils';
import CAN from '../../../casl/can';
import { Action, Resource } from '../../../casl/constants';
import AddNewBoradcast from '../add/newbroadcast.container';
import { ADD_BROADCAST_ACTION, STATUS_ENUM, broadcastColumnConfig } from '../../../utils/constants/broadcastConstants';
import { FILTER_KEYS } from '../../../utils/constants/userManagementConstant';

const BroadListViewer = (props) => {
    const navigate = useNavigate();
  
    const statuses = [
        { id: 'all', label: 'All', count: allCount(props?.statusCount ? props?.statusCount :0), className: 'statusAll', color: '#CCCCCC', outline: "#9E9E9E" },
        { id: 'scheduled', label: 'Scheduled', count: props?.statusCount?.scheduled ? props?.statusCount?.scheduled : 0, color: ' #FFF1BB', infoMessage: "scheduled", outline: "#F4D55B" },
        { id: 'live', label: 'Live', count: props?.statusCount?.live ? props?.statusCount?.live : 0, color: '#9FD59F', infoMessage: "live", outline: "#547F54" },
        { id: 'closed', label: 'Closed', count: props?.statusCount?.closed ? props?.statusCount?.closed : 0, color: '#E8E8E8', infoMessage: "closed", outline: "#C2C2C2" },

    ];
    const defaultStatuses = statuses.reduce((acc, status) => ({ ...acc, [status.id]: true }),{});
    const checkedStatuses = props.statusFilter || defaultStatuses;
    // const [checkedStatuses, setCheckedStatuses] = useState(statuses.reduce((acc, status) => ({ ...acc, [status.id]: true }), {}));
    const [sortOrder, setSortOrder] = useState("desc");
    const handleStatusChange = (newCheckedStatuses) => {
        // setCheckedStatuses(newCheckedStatuses);
        props.setStatusFilter(FILTER_KEYS.BROADCAST,newCheckedStatuses);
    };
    const toggleSortOrder = () => {
        setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    };
     const resetsecondaryFilter = () => { };
      useEffect(() => {
        //  props.getBroadcastList()
        const statusFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
          if(!checkAllFalse(checkedStatuses)){
           props.getBroadcastList(null,statusFilter,sortOrder);
          }
    }, [checkedStatuses, sortOrder]);

    const fetchData = () => {
      if (props?.data?.next) {
        const statusFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
        props.getBroadcastList(props?.data?.next,statusFilter,sortOrder);
      }
    };

    // const gotoDetail = (requestId, notificationId) => {
    //     navigate(`/ServiceRequestDetail/${requestId}`);
    //     if (notificationId?.length > 0) {
    //         notificationId.forEach(id => {
    //             const payload = {
    //                 read: true,
    //             };
    //             props.ReadNotification(payload, id);
    //         });
    //     }
    // }

    const getStatusLegendColorClass = (status) => {
        switch (true) {
            case status === STATUS_ENUM.SCHEDULE:
                return "scheduled";
            case status === STATUS_ENUM.LIVE:
                return "live";
            case status === STATUS_ENUM.CLOSED:
                return "closed";
            default:
                return status;
        }
    };
      
    const headers = [
        <div className={styles.organisationName} key="title"><div className={styles.orgname}>Title</div></div>,
        <div className={styles.organisationName} key="message"><div className={styles.orgname}>Messages</div></div>,
        <div className={styles.organisationName} key="recipients"><div className={styles.orgname}>Recipients</div></div>,
        <div className={styles.organisationName} key="startdate"><div className={styles.orgname}>Scheduled Date</div></div>,
        <div className={styles.organisationName} key="enddate"><div className={styles.orgname}>End Date</div><img className={`${styles.sorting} ${sortOrder === 'desc' ? styles.desc : styles.asc}`} src={IMAGES.sorticon} onClick={toggleSortOrder} alt="sort" /></div>,
    ]

   const mappedData = props?.data?.data?.map((item) => {
         const colorClass = getStatusLegendColorClass(item?.status?.value);
          const match = props.notificationdata?.find(row => row.detailsId === item.id);
          const ids = filterAndMapIds(props.notificationdata, item.id);
          const highlightClass = match ? styles.highlightedRow : '';
          return {
             title: <span className={`${styles.orglgname} ${styles.posrelative}  ${match ? styles.boldid : ""}`}>
                     <span className={`${highlightClass}`}></span>
                 <SecondaryTooltip text={colorClass?.replace(/_/g, ' ')?.replace(/\b\w/g, char => char?.toUpperCase())} positions={['bottom', 'left']}><span className={`${styles.statusLegendsIcon} ${styles[colorClass]} ${match ? styles.margingleft : ""}`} /></SecondaryTooltip>
                 
                 {/* <SecondaryTooltip text={item?.title} positions={['bottom', 'right']} > */}
                    <span className={styles.truncate}>
                        <AddNewBoradcast actionType={ADD_BROADCAST_ACTION.BROADCAST_DETAILS} initaldata={item} checkedStatuses={checkedStatuses}/>
                        {/* {item?.serviceRequestId} */}
                     </span>
                 {/* </SecondaryTooltip> */}
            </span>,
            message: <span className={`${styles.customDataContent} `}>
            <SecondaryTooltip customCss={"broadcastCss"} text={item?.message?.split('\n')?.map((line, index) => <span key={index}>{line}<br/></span>)} positions={['bottom', 'right']}><span className={styles.truncate}>{item?.message}</span></SecondaryTooltip>
             </span>,
             recipients: <span className={`${styles.customDataContent}`}><SecondaryTooltip text={Array.isArray(item?.recipients)? item?.recipients
                ?.map(r => (r === 'customer' ? 'Customer' : r === 'internal' ? 'Internal' : r))?.join(', '): item?.recipients} positions={['bottom', 'right']}>{Array.isArray(item?.recipients)? item?.recipients
                ?.map(r => (r === 'customer' ? 'Customer' : r === 'internal' ? 'Internal' : r))?.join(', '): item?.recipients}</SecondaryTooltip></span>,
             startdate: <span className={`${styles.customDataContent}`}><SecondaryTooltip text={formatDate(item?.startTime)} positions={['bottom', 'right']}>{formatDate(item?.startTime)}</SecondaryTooltip></span>,
             enddate: <span className={`${styles.customDataContent}`}><SecondaryTooltip text={formatDate(item?.expiryTime)} positions={['bottom', 'right']}>{formatDate(item?.expiryTime)}</SecondaryTooltip></span>,
           
         };
     });
    return (
        <>
            <div className={styles.wrapperchild}>
                {props.isLoading&& (
         <Loader />
        )}
                <InfiniteScroll
                    dataLength={props.data.data?.length}
                    next={() => {
                      if(!checkAllFalse(checkedStatuses)){
                        fetchData();
                      }
                    }}
                   hasMore={!checkAllFalse(checkedStatuses) ? props?.data?.next : null}
                   loader={<Loader />}
                >
                    <div className={styles.statussection}>
                        <div className={styles.headermsg}>Broadcast Message Listings</div>
                        <div className={styles.statussecti}>
                        <Status statuses={statuses} onStatusChange={handleStatusChange} checkedStatuses={checkedStatuses} infoImage={IMAGES.infoCircle} onResetfilter={resetsecondaryFilter} />
                        </div>
                    </div>
                    <div className={styles.note}>Please note that a maximum of two broadcast messages can be <span className={styles.notespan}>Live</span> at any given time.</div>
                    <Table headers={headers} data={checkAllFalse(checkedStatuses) ? [] : mappedData} height="auto" width="100%" columnConfig={broadcastColumnConfig} isWidth={true}
                        nodata={!props.isLoading&&mappedData?.length===0?"No Data.":"No Data."}
                    />
                </InfiniteScroll>
            </div>
        </>
    )
}

export default BroadListViewer;

